import { fetchQueryColumnsFromDimension, } from '@thoughtspot/ts-chart-sdk';
import { DATA_SIZE_LIMIT } from './types';
import { getAllDimensionCols, getMeasureCols, isMeasureNameColumn } from './helpers';
export function getFieldsByEncoding(chartConfigs, encodingKeys) {
    let rowFields = [];
    let colFields = [];
    const otherFields = [];
    chartConfigs.forEach((config) => {
        config.dimensions.forEach((dim) => {
            const columns = fetchQueryColumnsFromDimension(dim);
            switch (dim.key) {
                case encodingKeys.rows: {
                    rowFields = getAllDimensionCols(columns).slice();
                    otherFields.push(...getMeasureCols(columns));
                    break;
                }
                case encodingKeys.columns: {
                    colFields = getAllDimensionCols(columns).slice();
                    otherFields.push(...getMeasureCols(columns));
                    break;
                }
                default: {
                    otherFields.push(...columns);
                }
            }
        });
    });
    return { rowFields, colFields, otherFields };
}
export function partitionArrayByIndex(arr, index) {
    return [
        getAllDimensionCols(arr.slice(0, index)),
        getAllDimensionCols(arr.slice(index)),
    ];
}
export function getExcludedFields(otherFields, excludedAttrs) {
    const names = new Set(excludedAttrs.map((d) => d.name));
    return otherFields.filter((field) => !names.has(field.name));
}
export function getMeasureNameField(mainFields) {
    return mainFields.find(isMeasureNameColumn) ?? null;
}
export function getUniqueQueries(queries) {
    const map = new Map();
    queries.forEach((query) => {
        if (!query.queryColumns.length)
            return;
        const key = query.queryColumns
            .map((c) => c.name)
            .sort()
            .join(',');
        map.set(key, query);
    });
    return [...map.values()];
}
export function generateQueryParams(queries, params) {
    return queries.map((query) => ({
        ...query,
        queryParams: {
            size: params?.size || DATA_SIZE_LIMIT,
            offset: params?.offset,
        },
    }));
}
//# sourceMappingURL=fields.js.map